import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConsultRepository } from '../../repositories/consult.repository';
import { ConsentResponseModel } from '../../models/consult/consent-response.model';
export class GetConsentPendientByIdUseCase implements UseCase<{idAtencion: string, idConsentimientoInformado:string}, ConsentResponseModel> {
    constructor(private ConsultRepository: ConsultRepository) { }
    execute(
        params: {idAtencion: string, idConsentimientoInformado:string },
    ): Observable<ConsentResponseModel> {
        return this.ConsultRepository.getConsentPendientById(params);
    }
}